import { ReactNode } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { SidebarProvider } from '../../contexts/SidebarContext';
import { useSidebar } from '@hooks/useSidebar';
import styles from '@/styles/layout/AdminLayout.module.scss';

interface AdminLayoutProps {
  children: ReactNode;
}

const AdminLayoutContent = ({ children }: AdminLayoutProps) => {
  const { isExpanded } = useSidebar();

  return (
    <div className={styles.layout}>
      <Sidebar />
      <Header />
      <main
        className={styles.main}
        style={{ marginLeft: isExpanded ? '256px' : '64px' }}
      >
        {children}
      </main>
    </div>
  );
};

const AdminLayout = ({ children }: AdminLayoutProps) => {
  return (
    <SidebarProvider>
      <AdminLayoutContent>{children}</AdminLayoutContent>
    </SidebarProvider>
  );
};

export default AdminLayout;
